import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../language/keys';

type PageErrorBannerProps = {
  message?: string,
}

// todo: add refresh button
export const PageErrorBanner = ({
  message,
}: PageErrorBannerProps): JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Alert severity="error">
      {message || translate(STRING_KEYS.FATAL_PAGE_ERROR)}
    </Alert>
  );
};

PageErrorBanner.defaultProps = {
  message: undefined,
};
